import * as React from 'react';
import { useGetIdentity } from 'react-admin';
import AccessDenied from '../AccessDenied';

const superAdminPermissions = 'SUPER_ADMIN';

export const withPermissions = (
  WrappedComponent,
  requiredIdentityes,
  requiredRoles,
) => (props) => {
  const { identity } = useGetIdentity();
  const isSuperAdmin = identity?.roles.includes(superAdminPermissions);

  if (!isSuperAdmin) {
    if (
      (requiredIdentityes && !identity)
      || !requiredIdentityes?.includes(identity?.type)
    ) {
      return <AccessDenied />;
    }
    if (
      !identity
      || (requiredRoles && !requiredRoles.every((role) => identity.roles.includes(role)))
    ) {
      return <AccessDenied />;
    }
  }
  return (
    <WrappedComponent
      {...props}
    />
  );
};
